/**
 * menuFiltreEmploi.
 *
 */

// Import
import './menuFiltreEmploi.scss';
import $ from 'jquery';
import 'bootstrap/js/dist/tooltip';

$(document).ready(function() {


    //$( "#user-menu li " ).find( "a" ).css( "color", "red" );D:\projets\gab-uiversel\html\wp-content\themes\401372-service-des-ressources-humaines-vradho
    //$('[data-toggle="tooltip"]').tooltip();
    //$( "#user-menu li:first a" ).append( "<span class='interrogation'  data-toggle='tooltip' data-original-title='Connectez-vous à SIGA pour : modifier vos informations personnelles, obtenir vos feuillets fiscaux, consulter vos relevés de paie, etc.'> </span>" );
    $( "#menuFiltreEmploi li.menu-item-7827 a" ).append( "<sup class='interrogation' data-toggle='tooltip' data-original-title='Une connexion sera demandée.'></sup>" );

    $('[data-toggle="tooltip"]').tooltip();
});

